// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__2X4pa","dashboardTables":"dashboard_dashboardTables__XpiQN"};